export default "__VITE_ASSET__eaff2695__"